import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import { SingleDatePicker } from 'react-dates';
import ModalAlteracoes from '../../../Components/Modal-Alteracoes/Modal-Alteracoes';
import Usuario from '../../../Utils/Usuario';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import './Special-Areas.scss';
import TableContent from '../../../Components/Special-Areas/Table-Content';
import ModalContent from '../../../Components/Special-Areas/Modal-Content';
import ColorPicker from '../../../Components/Color-Picker/Color-Picker';
import ImagemFukyo from '../../../Components/Imagem-Fukyo/Imagem-Fukyo';
// import update from 'immutability-helper';

class AreaDetails extends Component {

    constructor(props) {
        super(props);
        this.apiArea = this.apiArea.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.mudaStatusArea = this.mudaStatusArea.bind(this);
        this.toggleSucessoAlteracao = this.toggleSucessoAlteracao.bind(this);
        this.habilitaSalvar = this.habilitaSalvar.bind(this);
        this.toggleModalPendencia = this.toggleModalPendencia.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.togglePub = this.togglePub.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.voltar = this.voltar.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.setSelectPublico = this.setSelectPublico.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.toggleModalContent = this.toggleModalContent.bind(this);
        this.newContent = this.newContent.bind(this);
        this.inserirConteudo = this.inserirConteudo.bind(this);
        this.removerConteudo = this.removerConteudo.bind(this);
        this.setColor = this.setColor.bind(this);
        this.toggleConfirmaExclusao = this.toggleConfirmaExclusao.bind(this);

        this.state = {
            isLoadingArea: true,
            isLoadingAlteracoes: false,
            isLoadingStatus: false,
            novaArea: this.props.match.params.idAreaEspecial === "nova-area",
            temAlteracao: false,
            tags: [],
            habilitaSalvar: false,
            modalPendencia: false,
            pendencias: [],
            hasError: false,
            errorMessage: '',
            verificacaoAcesso: false,
            nomeArea: '',
            mensagemSaudacao: '',
            tituloSaudacao: '',
            urlImagem: '',
            corTema: '',
            idNivelAcesso: 3,
            dtPubAux: null,
            modalContent: false,
            labelNewContent: '',
            typeNewContet: null,
            idLista: '',
            modalConfirmaExclusao: false,
        }

        this.Configurations = new Configurations();

        this.divisoesOptions = [
            { label: "DF ", value: "DF" },
            { label: "DS ", value: "DS" },
            { label: "DFJ", value: "DFJ" },
            { label: "DMJ", value: "DMJ" },
            { label: "DE ", value: "DE" },
        ];

        this.coordenadoriasOptions = [
            { label: "CCLP", value: "CCLP" },
            { label: "CNSP", value: "CNSP" },
            { label: "CGSP", value: "CGSP" },
            { label: "CLP", value: "CLP" },
            { label: "CNOP", value: "CNOP" },
            { label: "CBSF", value: "CBSF" },
            { label: "CRO", value: "CRO" },
            { label: "CRC", value: "CRC" },
            { label: "CSMRJ", value: "CSMRJ" },
            { label: "CRE OESTE", value: "CRE OESTE" },
            { label: "CRE LESTE", value: "CRE LESTE" },
            { label: "CRE PARANÁ", value: "CRE PARANÁ" },
            { label: "CRE SUL", value: "CRE SUL" },
        ];

        this.columnsA = [
            {
                Header: '#',
                className: 'pointer text-center',
                width: 40,
                Cell: row => <span>{row.index + 1}</span>
            },
            {
                Header: 'Título',
                accessor: 'titulo',
                className: 'text-center',
                // width: 200
            },
            {
                Header: 'Veículo',
                accessor: 'siglaVeiculo',
                className: 'text-center',
                width: 80
            },
            {
                Header: 'idConteudo',
                accessor: 'idConteudo',
                className: 'text-center',
                width: 120
            },
            {
                Header: 'Dt. inclusão',
                accessor: 'dtInclusao',
                className: 'text-center pointer',
                width: 140,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Usuário',
                accessor: 'nomeUsuario',
                className: 'text-center',
                width: 120
            },
            {
                Header: '',
                className: 'text-center pointer',
                width: 80,
                // Cell: (row) => <div onClick={() => this.removerConteudo(row.original.idLista)}><i className="text-danger far fa-trash-alt"></i></div>
                Cell: (row) => <div onClick={() => this.toggleConfirmaExclusao(row.original.idLista)}><i className="text-danger far fa-trash-alt"></i></div>
            },

        ];

        this.columnsB = [
            {
                Header: '#',
                className: 'pointer text-center',
                width: 40,
                Cell: row => <span>{row.index + 1}</span>
            },
            {
                Header: 'Título',
                accessor: 'titulo',
                className: 'text-center',
                // width: 200
            },
            {
                Header: 'Programa',
                accessor: 'siglaVeiculo',
                className: 'text-center',
                width: 360
            },
            {
                id: 'idPrograma',
                Header: row => row.data[0]._original.tipo === 2 ? 'idPodcast' : 'idVideoPrograma',
                accessor: row => row.tipo === 2 ? row.idPoadcast : row.idVideoPrograma,
                className: 'text-center',
                width: 80
            },
            {
                id: 'idEpisodio',
                Header: row => row.data[0]._original.tipo === 2 ? 'idEpisodio' : 'idVideoEpisodio',
                accessor: row => row.tipo === 2 ? row.idEpsodio : row.idVideoEpisodio,
                className: 'text-center',
                width: 80
            },
            {
                Header: 'Dt. inclusão',
                accessor: 'dtInclusao',
                className: 'text-center pointer',
                width: 140,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Usuário',
                accessor: 'nomeUsuario',
                className: 'text-center',
                width: 120
            },
            {
                Header: '',
                className: 'text-center pointer',
                width: 80,
                // Cell: (row) => <div onClick={() => this.removerConteudo(row.original.idLista)}><i className="text-danger far fa-trash-alt"></i></div>
                Cell: (row) => <div onClick={() => this.toggleConfirmaExclusao(row.original.idLista)}><i className="text-danger far fa-trash-alt"></i></div>
            },

        ];

        this.columnsC = [
            {
                Header: '#',
                className: 'pointer text-center',
                width: 40,
                Cell: row => <span>{row.index + 1}</span>
            },
            {
                Header: 'Título',
                accessor: 'titulo',
                className: '',
                // width: 200
            },
            {
                Header: 'Url',
                accessor: 'uri',
                className: '',
                width: 550,
                Cell: row =>
                    <a href={row.value} target="_blank" rel="noopener noreferrer">{row.value}</a>
            },
            {
                Header: 'Imagem',
                className: 'pointer',
                accessor: 'urlImagem',
                width: 100,
                Cell: row =>
                    <ImagemFukyo className="img img-fluid w-100" src={row.value} alt={`imagem`} />
                // <div className="w-25" style={{ backgroundImage: `url(${row.value})` }} />

            },
            {
                Header: 'Dt. inclusão',
                accessor: 'dtInclusao',
                className: 'text-center pointer',
                width: 140,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Usuário',
                accessor: 'nomeUsuario',
                className: 'text-center',
                width: 120
            },
            {
                Header: '',
                className: 'text-center pointer',
                width: 80,
                // Cell: (row) => <div onClick={() => this.removerConteudo(row.original.idLista)}><i className="text-danger far fa-trash-alt"></i></div>
                Cell: (row) => <div onClick={() => this.toggleConfirmaExclusao(row.original.idLista)}><i className="text-danger far fa-trash-alt"></i></div>
            },

        ];

        this.tiposConteudo = [
            {
                tipo: 1,
                columns: this.columnsA,
                headerLabel: "artigos",
                btnLabel: "novo artigo"
            },
            {
                tipo: 2,
                columns: this.columnsB,
                headerLabel: "podcasts",
                btnLabel: "novo podcast"
            },
            {
                tipo: 3,
                columns: this.columnsB,
                headerLabel: "vídeos",
                btnLabel: "novo vídeo"
            },
            {
                tipo: 4,
                columns: this.columnsC,
                headerLabel: "links",
                btnLabel: "novo link"
            },
            {
                tipo: 5,
                columns: this.columnsC,
                headerLabel: "arquivos",
                btnLabel: "novo arquivo"
            },
        ]
    }
    componentWillUnmount() {
        // if (!window.location.href.includes(`conteudo/${this.props.match.params.periodico}`)) Session.clearInfos();
    }

    componentWillMount() {
        let _permissoes = [1, 4, 12, 14];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        if (!found) {
            this.props.history.push({ pathname: '/permissao-negada' });
        }
        else {
            this.setState({
                areaEspecial: {
                    idAreaEspecial: this.props.match.params.idAreaEspecial
                },
                verificacaoAcesso: true,
            })
        }
    }

    componentDidMount() {
        // this.setState({ isLoadingArea: true });
        if (this.state.verificacaoAcesso) {
            if (!this.state.novaArea) {
                this.apiArea();
            }
            else this.setState({
                nomeArea: '',
                corTema: '',
                mensagemSaudacao: '',
                tituloSaudacao: '',
                urlImagem: '',
                idNivelAcesso: 1,
                dtPubAux: null,
                arrayConteudos: [],
                publicoDivSelecionado: [],
                publicoCoordSelecionado: [],
                isLoadingArea: false,
            })
        }
    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value, temAlteracao: true })
    }

    habilitaSalvar() {
        const _nomeValido = this.state.nomeArea.trim() !== '';
        const _dtPubValida = !!this.state.dtPubAux;

        const _infosObrigatorias = [
            { campo: "Nome", valido: _nomeValido },
            { campo: "Data de Publicação", valido: _dtPubValida },
        ];

        const _pendencias = _infosObrigatorias.filter(item => !item.valido);

        this.setState({ habilitaSalvar: _nomeValido * _dtPubValida }, () => this.salvarAlteracoes(_pendencias))
    }

    salvarAlteracoes(_pend) {
        if (this.state.habilitaSalvar) {
            const _salvarAreaEspecial = {
                ...this.state.areaEspecial,
                nome: this.state.nomeArea,
                saudacao: {
                    titulo: this.state.tituloSaudacao,
                    mensagem: this.state.mensagemSaudacao,
                    foto: this.state.urlImagem
                },
                dtPublicacao: moment(this.state.dtPubAux).format(),
                cores: { tema: this.state.corTema },
                idNivelAcesso: parseInt(this.state.idNivelAcesso, 10),
                publico: {
                    divisoes: this.state.publicoDivSelecionado.map(item => item.value),
                    coordenadorias: this.state.publicoCoordSelecionado.map(item => item.value),
                },
                conteudos: this.state.arrayConteudos,
                ativo: this.state.novaArea ? false : this.state.areaEspecial.ativo
            }

            this.setState({ areaEspecial: _salvarAreaEspecial, isLoadingAlteracoes: true }, () => {
                const { idAreaEspecial } = this.props.match.params;
                if (this.state.novaArea) {
                    axios.post(this.Configurations.apiBasePath + `/areas-especiais`, _salvarAreaEspecial).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                } else {
                    axios.put(this.Configurations.apiBasePath + `/areas-especiais/${idAreaEspecial}`, _salvarAreaEspecial).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                }
            })

        } else {
            this.setState({ pendencias: _pend }, () => this.toggleModalPendencia());
        }

    }

    mudaStatusArea() {
        const { idAreaEspecial } = this.props.match.params;
        this.setState({ isLoadingStatus: true });
        axios.put(this.Configurations.apiBasePath + `/areas-especiais/${idAreaEspecial}/toggle`).then(response => {
            this.setState({ isLoadingStatus: false })
            this.apiArea();
        }).catch(this.handleError);
    }

    apiArea() {
        const { idAreaEspecial } = this.props.match.params;
        this.setState({ isLoadingArea: true });
        axios.get(this.Configurations.apiBasePath + `/areas-especiais/${idAreaEspecial}`).then(response => {
            const _area = response.data.areaEspecial;
            this.setState({
                areaEspecial: _area,
                nomeArea: _area.nome,
                corTema: _area.cores.tema,
                mensagemSaudacao: _area.saudacao.mensagem,
                tituloSaudacao: _area.saudacao.titulo,
                urlImagem: _area.saudacao.foto,
                idNivelAcesso: _area.nivelAcesso.idNivelAcesso,
                dtPubAux: _area.dtPublicacao,
                arrayConteudos: _area.conteudos.map((item, index) => {
                    return {
                        ...item,
                        idLista: index
                    }
                }),
                publicoDivSelecionado: this.setSelectPublico(_area.publico.divisoes),
                publicoCoordSelecionado: this.setSelectPublico(_area.publico.coordenadorias),
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingArea: false }));
    }

    toggleSucessoAlteracao() {
        if (this.state.modalSucessoAlteracao) {
            this.setState({ modalSucessoAlteracao: false }, () =>
                window.history.go(-1)
            );
        } else this.setState({ modalSucessoAlteracao: true })
    }

    toggleModalPendencia() {
        this.setState({ modalPendencia: !this.state.modalPendencia })
    }

    handleRadio(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    onDateChange(date) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ dtPubAux: date })
    }

    togglePub() { this.setState({ modalPub: !this.state.modalPub }) }

    _outsideRange(day) {
        // return day.format() <= moment().format();
    }

    onChangeInput(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        const _name = e.target.name;
        // e.preventDefault();
        // this.setState({ artigo: update(this.state.artigo, { [_name]: { $set: e.target.value } }) })
        this.setState({ [_name]: e.target.value });
    }

    voltar() {
        this.state.temAlteracao ? this.toggleModalAlteracoes() : window.history.go(-1)
    }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }

    setSelectPublico(arrayPublico) {
        const newArray = arrayPublico.map(item => {
            return { label: item, value: item }
        })
        return newArray
    }

    handleSelectChange(e, o) {
        this.setState({ temAlteracao: true })
        const _name = o.name;
        let _list = this.state[_name];
        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                break;
            case "clear":
                this.setState({ [_name]: [] });
                return o;
            default:
                _list.push(o.option);
                break;
        }

        this.setState({ [_name]: _list });
        return o;

    }

    newContent(conteudo) {
        this.setState({ labelNewContent: conteudo.btnLabel, typeNewContet: conteudo.tipo }, () => {
            this.toggleModalContent();
        })
    }

    toggleModalContent() {
        this.setState({ modalContent: !this.state.modalContent }, () => {
            if (!this.state.modalContent) this.setState({ labelNewContent: '', typeNewContet: null })
        })
    }

    inserirConteudo(inputs, tipo) {
        this.setState({ temAlteracao: true })
        const _arrayAux = this.state.arrayConteudos;
        _arrayAux.push({
            tipo: tipo,
            ...inputs,
            novo: true,
            idLista: Math.max.apply(Math, this.state.arrayConteudos.map(function (o) { return o.idLista; })) + 1
        })
        // console.log(_arrayAux)
        // this.setState({ arrayConteudos:  })
    }

    removerConteudo() {
        this.setState({ temAlteracao: true })
        const _arrayAux = this.state.arrayConteudos;
        const _index = _arrayAux.findIndex(item => item.idLista === this.state.idLista);
        _arrayAux.splice(_index, 1);
        // console.log(_arrayAux)
        // this.setState({ arrayConteudos:  })
        this.setState({ modalConfirmaExclusao: false, idLista: '' })
    }

    toggleConfirmaExclusao(idLista) {
        this.setState({
            modalConfirmaExclusao: !this.state.modalConfirmaExclusao
        }, () => {
            this.setState({
                idLista: this.state.modalConfirmaExclusao ? idLista : '',
            })
        })
    }

    setColor(color) {
        this.setState({
            corTema: color.hex,
            temAlteracao: true
        })
    }

    render() {
        return (
            <div className="row area-details">
                <div className="col-12">
                    {this.state.isLoadingArea ? (
                        <div className="row no-gutters">
                            <div className="col-12 text-center py-5">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-12 col-lg-10 text-center text-lg-left">
                                <h3 className="d-none d-lg-block">{this.state.novaArea ? 'Nova Área Especial' : `Área Especial "${this.state.nomeArea}"`}</h3>
                                <h4 className="d-lg-none">{this.state.novaArea ? 'Novo Área Especial' : 'Área Especial'}</h4>
                                {!this.state.novaArea && <h5 className="d-lg-none">"{this.state.nomeArea}"</h5>}

                            </div>
                            <div className="col-12 col-lg-2 text-center text-lg-right">
                                <button onClick={this.voltar} className="btn btn-outline-secondary">voltar</button>
                            </div>
                            <div className="col-12 col-lg-12 py-3">
                                <small><small>(*)</small> informações obrigatórias</small>
                            </div >
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-5 py-3">
                                        <label>Nome da área especial<sup><small>(*)</small></sup></label>
                                        <input name="nomeArea" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.nomeArea} autoComplete="off" />
                                    </div>
                                    <div className="col-3 py-3">
                                        <div className="row">
                                            <div className="col-12">
                                                <label>Data de Publicação<sup><small>(*)</small></sup></label>
                                            </div>
                                            <div className="col-12">
                                                <SingleDatePicker
                                                    date={this.state.dtPubAux !== null ? moment(this.state.dtPubAux) : null} // momentPropTypes.momentObj or null
                                                    onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                                    focused={this.state.focused} // PropTypes.bool
                                                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                                    id="your_unique_id" // PropTypes.string.isRequired,
                                                    orientation="horizontal"
                                                    anchorDirection="right"
                                                    openDirection="down"
                                                    verticalHeight={450}
                                                    numberOfMonths={1}
                                                    small={true}
                                                    phrases={this._phrases}
                                                    placeholder=""
                                                    displayFormat="DD/MM/YY"
                                                    isOutsideRange={this._outsideRange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4 py-3">
                                        <label>Escolha a cor do tema:</label>
                                        <ColorPicker colorHex={this.state.corTema} setColor={this.setColor} />
                                    </div>
                                    <div className="col-12 py-3">
                                        <label>Saudação</label>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-6 py-3">
                                                        <label>Título</label>
                                                        <input name="tituloSaudacao" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.tituloSaudacao} autoComplete="off" />
                                                    </div>
                                                    <div className="col-6 py-3">
                                                        <label>Url da imagem</label>
                                                        <input name="urlImagem" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.urlImagem} autoComplete="off" />
                                                    </div>
                                                    <div className="col-6 py-3">
                                                        <label>Mensagem</label>
                                                        <textarea rows={10} name="mensagemSaudacao" type="text" className="form-control w-100" onChange={this.handleOnChange} value={this.state.mensagemSaudacao} autoComplete="off" />
                                                    </div>
                                                    <div className="col-6 py-3">
                                                        <div className="div-img-capa" style={{ backgroundImage: `url(${this.state.urlImagem})` }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 col-lg-3 py-3">
                                                <label>Acesso</label>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="idNivelAcesso" id="excl" checked={parseInt(this.state.idNivelAcesso, 10) === 3} value={"3"} onChange={this.onChangeInput} />
                                                    <label className="form-check-label" htmlFor="excl">Exclusivo para assinantes</label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="idNivelAcesso" id="assoc" checked={parseInt(this.state.idNivelAcesso, 10) === 2} value={"2"} onChange={this.onChangeInput} />
                                                    <label className="form-check-label" htmlFor="assoc">Aberto para associados</label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="idNivelAcesso" id="publ" checked={parseInt(this.state.idNivelAcesso, 10) === 1} value={"1"} onChange={this.onChangeInput} />
                                                    <label className="form-check-label" htmlFor="publ">Aberto ao público</label>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-9 py-3">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label htmlFor="ddlTipoProcessamento">Divisões</label>
                                                            <Select
                                                                id="ddlDivs"
                                                                placeholder="Selecione uma ou mais divisões"
                                                                closeMenuOnSelect={true}
                                                                components={makeAnimated()}
                                                                defaultValue={this.state.publicoDivSelecionado}
                                                                isMulti
                                                                name="publicoDivSelecionado"
                                                                onChange={this.handleSelectChange}
                                                                options={this.divisoesOptions}
                                                            />
                                                            <small>Deixar vazio para selecionar todas as opções.</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label htmlFor="ddlTipoProcessamento">Coordenadorias</label>
                                                            <Select
                                                                id="ddlCoords"
                                                                placeholder="Selecione uma ou mais coordenadorias"
                                                                closeMenuOnSelect={true}
                                                                components={makeAnimated()}
                                                                defaultValue={this.state.publicoCoordSelecionado}
                                                                isMulti
                                                                name="publicoCoordSelecionado"
                                                                onChange={this.handleSelectChange}
                                                                options={this.coordenadoriasOptions}
                                                            />
                                                            <small>Deixar vazio para selecionar todas as opções.</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 py-4">
                                <div className="row no-gutters">
                                    {this.tiposConteudo.map((conteudo, index) => {
                                        return (
                                            <div key={index} className={`col-12 py-3`}>
                                                <div className="row no-gutters">
                                                    <div className={`col-12 offset-lg-5 col-lg-2 py-2 text-center`}>
                                                        <strong>Lista de {conteudo.headerLabel}</strong>
                                                    </div>
                                                    <div className={`col-12 py-2 col-lg-5 text-right`}>
                                                        <button onClick={() => this.newContent(conteudo)} className="btn btn-sm btn-outline-primary">+ {conteudo.btnLabel}</button>
                                                    </div>
                                                    {this.state.arrayConteudos.filter(item => item.tipo === conteudo.tipo).length > 0 ? (
                                                        <div className={`col-12 py-2`}>
                                                            <div className="card">
                                                                <div className="card-body p-0">
                                                                    <TableContent
                                                                        listaConteudo={this.state.arrayConteudos.filter(item => item.tipo === conteudo.tipo)}
                                                                        columns={conteudo.columns}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <p className="m-0 text-success"><small className="font-weight-bold font-italic">Novos itens adicionados estão indicados pela cor verde.</small></p>
                                                        </div>
                                                    ) : (
                                                        <div className={`col-12 text-center`}>
                                                            <p className="">Nenhum item adicionado até o momento.</p>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="col-12 py-3 text-center">
                                {this.state.temAlteracao && (
                                    <p className="text-danger mb-2 mr-2"><i>As alterações ainda não foram salvas.</i></p>
                                )}
                                {this.state.isLoadingAlteracoes ? (
                                    <div className="spinner-border text-primary" role="status" />
                                ) : (
                                    <button onClick={this.habilitaSalvar} disabled={!this.state.temAlteracao} className='btn btn-outline-success'>salvar alterações</button>
                                )}
                            </div >
                        </div>
                    )}
                </div>

                <Modal isOpen={this.state.modalSucessoAlteracao} toggle={this.toggleSucessoAlteracao}>
                    <ModalHeader toggle={this.toggleSucessoAlteracao}>
                        {this.state.novaArea ? 'Nova Área Especial' : 'Edição de Área Especial'}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.novaArea ? 'Nova área especial criada com sucesso! :)' : 'Alterações realizadas com sucesso! :)'}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleSucessoAlteracao}>ok</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalConfirmaExclusao} toggle={this.toggleConfirmaExclusao}>
                    <ModalHeader toggle={this.toggleConfirmaExclusao}>Exclusão de conteúdo</ModalHeader>
                    <ModalBody>
                        <p className="m-0">Deseja confirmar a exclusão do item de conteúdo da área especial?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this.removerConteudo}>excluir</Button>
                        <Button color="secondary" onClick={this.toggleConfirmaExclusao}>voltar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalPendencia} toggle={this.toggleModalPendencia}>
                    <ModalHeader toggle={this.toggleModalPendencia}>Campos obrigatórios</ModalHeader>
                    <ModalBody>
                        <p>Por favor, preencha o(s) seguinte(s) campo(s) obrigatório(s):</p>
                        <ul>
                            {this.state.pendencias && this.state.pendencias.map((item, index) => {
                                return <li key={`campo-${index}`}>{item.campo}</li>
                            })}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleModalPendencia}>ok</Button>
                    </ModalFooter>
                </Modal>

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                // direcionaURL={'/conteudo'}
                // goBack={true}
                />
                <ModalAlteracoes
                    isOpen={this.state.modalAlteracoes}
                    toggle={this.toggleModalAlteracoes}
                />
                <ModalContent
                    isOpen={this.state.modalContent}
                    toggle={this.toggleModalContent}
                    label={this.state.labelNewContent}
                    tipo={this.state.typeNewContet}
                    inserirConteudo={this.inserirConteudo}
                />

            </div >
        )
    }
}

export default AreaDetails;